export const MAXIMUM_UPLOAD_SIZE_BYTES = 15728640;
